import { CSSProperties, PropsWithChildren } from "react";

/** A row in a striped list; every second row picks up a tinted background.
 *
 * `style` is passed through so `<Spacing asChild>` can place the row. */
export const StyledListItem: React.FC<
  PropsWithChildren<{ style?: CSSProperties }>
> = ({ children, style }) => (
  <div className="px-6 py-3 even:bg-[#f5f5f5]" style={style}>
    {children}
  </div>
);

/** The leading information column of a list row. */
export const StyledListInfo: React.FC<PropsWithChildren> = ({ children }) => (
  <div className="flex w-[95%] items-center justify-start pl-[10px]">
    {children}
  </div>
);

/** A padded, tinted block that groups one section of the assessment settings. */
export const AssessmentSettingsSection: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="bg-p0-neutral-10 p-[1em]">{children}</div>;
